import { Alert } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useDebounce } from '@/hooks/useDebounce';
import { useCheckProductNameDuplicates } from '@/hooks/useProductQueries';

import { ProductLink } from '../../components/ProductLink';

interface ProductDuplicateWarningProps {
  name: string | undefined;
  excludeProductId?: number;
}

const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;

const DuplicateList = styled.ul`
  margin: 4px 0 0;
  padding-left: 18px;

  li {
    margin-bottom: 2px;
  }
`;

export const ProductDuplicateWarning: React.FC<ProductDuplicateWarningProps> = ({
  name,
  excludeProductId,
}) => {
  const [debouncedName, setDebouncedName] = useState('');
  const debouncedSetName = useDebounce(setDebouncedName, 400);
  useEffect(() => {
    debouncedSetName(name || '');
  }, [name, debouncedSetName]);

  const { data: duplicateMatches } = useCheckProductNameDuplicates(debouncedName, excludeProductId);

  if (!duplicateMatches?.length) return null;

  return (
    <StyledAlert
      type="warning"
      showIcon
      message="Можливий дублікат товару"
      description={
        <DuplicateList>
          {duplicateMatches.map((product) => (
            <li key={product.id}>
              <ProductLink slug={product.slug} openInNewTab>
                {product.name}
              </ProductLink>
            </li>
          ))}
        </DuplicateList>
      }
    />
  );
};
